module.exports = __webpack_public_path__ + "img/cctv-default.0506afdb.png";